module.exports = __webpack_public_path__ + "static/media/kibitz_logo.e6b1ed9c.svg";